/** @jsx jsx */
// @ts-ignore
import { jsx, Flex, Text, SxStyleProp, Box, Image } from 'theme-ui'
import React, { FC, Fragment, ElementType, Ref } from 'react'
import {
  SelectedValue,
  ColorOption,
  Option,
  ColorOptionWithAvailability,
} from '~/components/parameters/color-parameter/types'
import ShippingLabel from '~/components/parameters/shipping-label'
import { ColorBoxV2 } from '~/componentsV2/colors/colorBox'
import { Link } from 'gatsby'
import { Tooltip } from 'react-tooltip'
import { space } from '~/gatsby-plugin-theme-ui'
import ImageWrapper from '~/components/image-wrapper'
import { uniqueId } from 'lodash'

type Props = {
  id: string
}

type TMountTooltipArgs = {
  id: string
}

export const useTooltip = ({ id }: Props) => {
  const unid = id + '-' + uniqueId()
  const ColorTooltip = () => {
    return (
      <Tooltip
        id={unid}
        arrowColor="transparent"
        clickable={true}
        // isOpen={true}
        place="top-start"
        render={({ content }) => {
          if (!content) return null

          const contentArray = content.split(';')
          return (
            <Box
              sx={{
                width: [175],
                bg: '#fff',
                p: ['none', space.sm],
                display: ['none', 'block'],
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                opacity: 1,
                cursor: 'pointer',
              }}
            >
              <ImageWrapper ratio={1} center>
                <Image
                  src={contentArray[1]}
                  loading="lazy"
                  alt={`${contentArray[0]} - color option` || 'Image Color'}
                  sx={{
                    width: '100%',
                  }}
                />
              </ImageWrapper>
              <Text
                sx={{
                  color: 'txt',
                  fontSize: '14px',
                  mt: [space.sm],
                }}
              >
                {contentArray[0]}
              </Text>
            </Box>
          )
        }}
        sx={{
          padding: '0 !important',
          boxShadow: 'none',
          opacity: '1 !important',
          zIndex: 10,
        }}
      />
    )
  }

  return {
    tooltipId: unid,
    createdContent: (title: string, image: string) => `${title};${image}`,
    Tooltip: ColorTooltip,
  }
}
